export default {
  dataRoom: 'غرفة البيانات',
  main: 'الأساسية',
  allCompanyFiles: 'جميع ملفات الشركة',
  yourFiles: 'ملفاتك',
  sharedLogs: 'سجلات المشاركة',
  description: 'الوصف',
  searchFileDocuments: 'البحث في الملفات، الوثائق، وما إلى ذلك',
  fileName: 'اسم الملف',
  sharedBy: 'تمت مشاركته من قبل',
  sharedTo: 'تمت مشاركته ل',
  expiryDate: 'تاريخ الانتهاء',
  expiredDate: 'تاريخ الانتهاء',
  sharedDate: 'تاريخ المشاركة',
  dataNotFound: 'البيانات غير موجودة',
  analytics: 'تحليلات',
  actions: 'الإجراءات',
  viewHeatmap: 'عرض الخريطة الحرارية',
  newFolder: 'مجلد جديد',
  share: 'مشاركة',
  delete: 'حذف',
  settings: 'إعدادات',
  createNewFolder: ' إنشاء مجلد جديد',
  folderName: 'اسم المجلد',
  download: 'تحميل',
  back: 'رجوع',
  submit: 'إرسال',
  watermark: 'علامة مائية',
  fieldRequired: 'هذه الخانة مطلوبه',
  userPermissions: 'صلاحيات المستخدم',
  shareFile: 'مشاركة الملف',
  selectDate: 'تحديد التاريخ',
  email: 'البريد الإلكتروني',
  receivers: 'المتلقون',
  'shared logs': 'سجلات المشاركة',
  receiverEmail: 'البريد الالكتروني للمتلقي',
  deleteWarning: 'انت على وشك حذف شئ مهم',
  deleteConfirmation: 'هل متأكد من حذف',
  file: 'ملف',
  yesDelete: 'نعم, حذف',
  viewCount: 'عدد المشاهدات',
  previewDuration: 'مدة المشاهدة',
  downloadCount: 'عدد التحميلات',
  lastModified: 'اخر تعديل',
  uploadFile: 'رفع الملف',
  rename: 'اعادة التسمية',
  open: 'فتح',
  copyTo: 'نسخ إلى',
  copyHere: 'إنسخ هنا',
  chooseFolderToCopyTo: 'اختر مجلد الوجهة',
  yes: 'نعم',
  cancel: 'الغاء',
  folderOptions: 'إعدادات المجلد',
  downloadable: 'قابل للتحميل',
  watermarked: 'ذو علامة مائية',
  shareExpiryDate: 'تاريخ إنتهاء المشاركة',
  selectAll: 'اختر الكل',
  itemSelected: '{{count}} عنصر محدد',
  itemsSelected: '{{count}} عناصر محددة',
  zoom: 'تكبير',
  previous: 'السابق',
  next: 'التالي',
  page: 'صفحة',
  goTo: 'الانتقال إلى',
  pageOf: 'صفحة {{pageNumber}} من {{pdfPages}}',
  preview: 'معاينة',
  scrollEngagement: 'التفاعل مع التمرير',
  readerReach: 'مدى وصول القراء',
  readerReachDescription: 'النسبة المئوية للجلسات التي وصلت إلى كل جزء من المستند.',
  documentDepth: 'عمق المستند',
  pageDepth: 'عمق الصفحة',
  status: 'الحالة',
  totalPages: 'إجمالي الصفحات',
  pageNumber: 'الصفحة {{page}}',
  pageDuration: 'الوقت في الصفحة',
  pageDurationHelp: 'إجمالي الوقت الذي قضاه هذا المساهم في هذه الصفحة.',
  maximumScrollDepth: 'أقصى عمق',
  maximumScrollDepthHelp: 'أقصى عمق رأسي وصل إليه هذا المساهم في هذه الصفحة.',
  minutesShort: 'د',
  secondsShort: 'ث',
  shareholder: 'المساهم',
  reached: 'تم الوصول',
  notReached: 'لم يتم الوصول',
  shareholderEngagementDisclaimer: 'تفاعل الصفحات للمساهم والملف المحددين.',
  scrollEngagementEmpty: 'لم يتم تسجيل أي تفاعل مع التمرير لهذا الملف حتى الآن.',
  scrollEngagementError: 'تعذر تحميل بيانات التفاعل مع التمرير.',
  scrollEngagementUnauthorized: 'ليس لديك صلاحية لعرض بيانات التفاعل مع التمرير.',
  scrollEngagementNotFound: 'لم يتم العثور على سجل التحليلات هذا للشركة المحددة.',
  scrollEngagementDisclaimer: 'يعرض مدى التمرير الإجمالي فقط، ولا يقيس الانتباه أو الاستيعاب.',
  halt: 'إيقاف',
  haltWarningModalTitle: 'إيقاف ملف مشترك',
  haltWarningModalContent: 'هل أنت متأكد أنك تريد إيقاف هذا الملف المشترك؟ لا يمكن التراجع عن هذا الإجراء.',
  extend: 'تمديد',
  extendModalTitle: 'تمديد سجل المشاركة',
  extendModalContent: 'اختر تاريخًا للتمديد إليه',
  confirm: 'تأكيد',
};
